export default "__VITE_ASSET__4P754cA$__"